import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaHome } from 'react-icons/fa';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>Sororin</h3>
          <p>Το κατάστημα ομορφιάς με τα πιο εξαιρετικά προϊόντα περιποίησης και πολυτέλειας στην Ελλάδα.</p>
          <p>Αριθμός Μητρώου: 77764607</p>
        </div>
        
        <div className="footer-section">
          <h3>Επικοινωνία</h3>
          <p><FaHome /> Loutron 27, Lagkadas 572 00, Greece</p>
          <p><FaPhone /> +302394023553</p>
          <p>Email: <a href="mailto:sororin@hotmail.com">sororin@hotmail.com</a></p>
            <p><a href="https://wa.me/302394023553">WhatsApp</a></p>
            <p><a href="https://viber.me/302394023553">Viber</a></p>
        </div>
        
        <div className="footer-section">
          <h3>Γρήγορες Συνδέσεις</h3>
          <Link to="/">Αρχική</Link>
          <Link to="/about">Σχετικά με εμάς</Link>
          <Link to="/contact">Επικοινωνία</Link>
          <Link to="/cart">Καλάθι</Link>
        </div>
        
        <div className="footer-section">
          <h3>Νομικές Πληροφορίες</h3>
          <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
          <Link to="/terms-conditions">Όροι Χρήσης</Link>
          <Link to="/refund-policy">Πολιτική Επιστροφών</Link>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2026 Sororin. Όλα τα δικαιώματα διατηρούνται.</p>
        <div className="footer-links">
          <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
          <Link to="/terms-conditions">Όροι Χρήσης</Link>
          <Link to="/refund-policy">Πολιτική Επιστροφών</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;